import { render } from "./categorys.vue?vue&type=template&id=6711b0b9"
import script from "./categorys.vue?vue&type=script&lang=js"
export * from "./categorys.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__